import state from './moduloBillingState';
import mutations from './moduloBillingMutations';
import actions from './moduloBillingActions';
import * as getters from './moduloBillingGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
